import icon from './icon';

interface TooltipProps {
  image: string;
  description: string;
  name: string;
  url: string;
}

export default function getTooltip(properties: TooltipProps) {
  const image = typeof properties.image !== 'undefined' && properties.image ? `
    <img class="map-popup__image" src="${properties.image}" alt="">
  ` : '';
  const description = typeof properties.description !== 'undefined' && properties.description ? `
    <div class="map-popup__description">
      ${properties.description}
    </div>
  ` : '';

  return `
    <a href="${properties.url}" class="map-popup__content d-flex align-items-center">
      ${image}
      <div class="map-popup__text">
        <div class="map-popup__heading">${properties.name} ${icon('arrow-right')}</div>
      </div>
    </a>
  `;
}
